/**
 * Matches react-alice-carousel breakPoints in VideoCarousel for item counts.
 */
export const carouselItemsForCatalogWidth = (catalogWidthPx: number): number => {
  if (catalogWidthPx >= 1440) {
    return 5;
  }
  if (catalogWidthPx >= 1200) {
    return 4;
  }
  if (catalogWidthPx >= 900) {
    return 3;
  }
  if (catalogWidthPx >= 640) {
    return 2;
  }
  return 1;
};

/**
 * Approximate row height for a carousel track from catalog section width (first paint + resize).
 * Uses horizontal padding from .catalog-section (50px each) and ~10px horizontal padding per card.
 */
export const estimateCarouselRowHeightPx = (catalogWidthPx: number): number => {
  if (catalogWidthPx <= 0) {
    return 0;
  }

  const items = carouselItemsForCatalogWidth(catalogWidthPx);
  const inner = Math.max(0, catalogWidthPx - 100);
  const itemWidth = inner / items - 20;
  const height = itemWidth * (9 / 16);

  return Math.max(Math.round(height), 120);
};
